import { render, staticRenderFns } from "./ProductFaceScanMetricsEditorCard.vue?vue&type=template&id=3e7a2d74&scoped=true&"
import script from "./ProductFaceScanMetricsEditorCard.vue?vue&type=script&lang=js&"
export * from "./ProductFaceScanMetricsEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a2d74",
  null
  
)

export default component.exports